<div class="segment vpo">
  <div class="filtri-container">
    <form novalidate [formGroup]="this.ixUtilFilter.ixFormGroup" class="CssForm filtri-forma">
      <div class="lang-container">
        <button
          class="lang-button"
          [class.font-bold]="this.jezik === Language.SI"
          (mousedown)="this.setLanguage(Language.SI, true)"
          style="padding: 1px 6px"
        >
          SLO
        </button>
        |
        <button
          class="lang-button lang-en"
          [class.font-bold]="this.jezik === Language.EN"
          (mousedown)="this.setLanguage(Language.EN, true)"
          style="padding: 1px 30px 1px 6px"
        >
          EN
        </button>
      </div>

      <ix-filter-group-dynamic
        #ixFilterGroup
        styleClass="m-0 text-base"
        id="vpoFiltri"
        [ixFormGroup]="this.ixUtilFilter.ixFormGroup"
        [filterTableConfig]="this.ixUtilFilter.model?.filterTableConfig || defaultFilterTableConfig"
        [(selectedFilterItems)]="this.selectedFilterItems"
        (removeSelectedFilterItemFromComponentEvent)="
          this.removeSelectedFilterItem($event.toString())
        "
        [showCloseIcon]="true"
        [showDodatnoTop]="false"
        [showSearchButton]="false"
        [buttonClass]="
          this.ixUtilFilter.ixFormGroup.dirty ? 'ui-button-secondary-dirty' : 'ui-button-secondary'
        "
      >
        <ng-template ixCustomLookupFilter id="naziv">
          <lib-filter-string
            [ixFormGroup]="this.ixUtilFilter.ixFormGroup"
            [stylePanel]="{ 'max-width': '300px', 'min-width': '200px' }"
            class="vsebina vpo-filter"
            [valueAll]="this.jezik === Language.EN ? 'All' : 'Vse'"
            field="naziv"
            [label]="
              this.ixUtilFilter.model?.filterTableConfig?.filters?.['naziv']?.label || 'Naziv'
            "
          >
          </lib-filter-string>
        </ng-template>

        <ng-template ixCustomLookupFilter id="nazivDS">
          <lib-filter-string
            [ixFormGroup]="this.ixUtilFilter.ixFormGroup"
            [stylePanel]="{ 'max-width': '300px', 'min-width': '200px' }"
            class="vsebina vpo-filter"
            [valueAll]="this.jezik === Language.EN ? 'All' : 'Vse'"
            field="nazivDS"
            [label]="
              this.ixUtilFilter.model?.filterTableConfig?.filters?.['nazivDS']?.label || 'Naziv'
            "
          >
          </lib-filter-string>
        </ng-template>

        <ng-template ixCustomLookupFilter id="obcinaLookupSeznam">
          <lib-filter-lookup
            [showCloseIcon]="true"
            [ixFormGroup]="this.ixUtilFilter.ixFormGroup"
            [label]="
              this.ixUtilFilter.model?.filterTableConfig?.filters?.['obcinaLookupSeznam']?.label ||
              'Občina'
            "
            field="obcinaLookupSeznam"
            displayField="naziv"
            [stylePanel]="{ 'max-width': '400px', 'min-width': '400px' }"
            [displayFooter]="true"
            [valueAll]="this.jezik === Language.EN ? 'All' : 'Vse'"
            [placeholder]="
              this.jezik === Language.EN ? 'Search by municipality.' : 'Išči po občinah.'
            "
            [footerMessage]="
              this.jezik === Language.EN
                ? 'Only the first 100 items are shown.'
                : 'Prikazanih je prvih 100 zapisov.'
            "
            class="vsebina vpo-filter"
            (ixFilterValueChange)="this.onObcinaLookupSeznamChange($event)"
          >
            <lib-obcina-lookup
              [header]="true"
              [lookupHeader]="
                this.ixUtilFilter.model?.filterTableConfig?.filters?.['obcinaLookupSeznam']
                  ?.label || 'Občina'
              "
            ></lib-obcina-lookup>
            <ng-template let-item>
              <lib-obcina-lookup [item]="item"></lib-obcina-lookup>
            </ng-template>
          </lib-filter-lookup>
        </ng-template>

        <ng-template ixCustomLookupFilter id="ukrepLookupSeznam">
          <lib-filter-lookup
            [showCloseIcon]="true"
            [ixFormGroup]="this.ixUtilFilter.ixFormGroup"
            [label]="
              this.ixUtilFilter.model?.filterTableConfig?.filters?.['ukrepLookupSeznam']?.label ||
              'Koda in naziv ukrepa'
            "
            field="ukrepLookupSeznam"
            displayField="koda"
            [stylePanel]="{
              'max-width': IxNgHtmlStaticUtils.mobile ? '400px' : '900px',
              'min-width': IxNgHtmlStaticUtils.mobile ? '400px' : '900px',
            }"
            [displayFooter]="true"
            class="vsebina vpo-filter"
            [valueAll]="this.jezik === Language.EN ? 'All' : 'Vse'"
            (ixFilterValueChange)="this.onUkrepLookupSeznamChange($event)"
            [single]="false"
            [showSelectedItems]="false"
          >
            <lib-ukrep-lookup [header]="true" [language]="this.jezik"></lib-ukrep-lookup>
            <ng-template let-item>
              <lib-ukrep-lookup [item]="item" [language]="this.jezik"></lib-ukrep-lookup>
            </ng-template>
          </lib-filter-lookup>
        </ng-template>

        <ng-template ixCustomLookupFilter id="skupniZnesek" #numberFilter>
          <lib-filter-number
            [format]="this.ixNgFormatService.format.FLOAT"
            [ixFormGroup]="this.ixUtilFilter.ixFormGroup"
            [stylePanel]="{ 'max-width': '400px', 'min-width': '300px' }"
            class="vsebina vpo-filter"
            [valueAll]="this.jezik === Language.EN ? 'All' : 'Vse'"
            field="skupniZnesek"
            [language]="this.jezik"
            [label]="
              this.ixUtilFilter.model?.filterTableConfig?.filters?.['skupniZnesek']?.label ||
              'Znesek skupaj EKJS, EKSRP in sofinanciranja'
            "
            maxField="skupniZnesekTo"
            minField="skupniZnesekFrom"
          >
          </lib-filter-number>
        </ng-template>

        <ng-template ixCustomLookupFilter id="rowsLookupSeznam">
          <lib-filter-lookup
            [showCloseIcon]="true"
            [ixFormGroup]="this.ixUtilFilter.ixFormGroup"
            [label]="
              this.ixUtilFilter.model?.filterTableConfig?.filters?.['rowsLookupSeznam']?.label ||
              'Št. zadetkov'
            "
            field="rowsLookupSeznam"
            [displayField]="this.jezik === Language.EN ? 'numberOfRowsAng' : 'numberOfRows'"
            [stylePanel]="{ 'max-width': '200px', 'min-width': '200px' }"
            [displayFooter]="true"
            class="vsebina vpo-filter"
            [valueAll]="this.jezik === Language.EN ? 'All' : 'Vse'"
            (ixFilterValueChange)="this.onRowsLookupSeznamChange($event)"
            [single]="true"
            [showSelectedItems]="false"
          >
            <lib-rows-lookup
              [header]="true"
              [lookupHeader]="
                this.ixUtilFilter.model?.filterTableConfig?.filters?.['rowsLookupSeznam']?.label ||
                'Št. zadetkov'
              "
            ></lib-rows-lookup>
            <ng-template let-item>
              <lib-rows-lookup [item]="item" [language]="this.jezik"></lib-rows-lookup>
            </ng-template>
          </lib-filter-lookup>
        </ng-template>
      </ix-filter-group-dynamic>

      <div class="grid mt-1 grid-gumbi">
        <div class="md:col-6 lg:col-6 flex justify-content-end">
          <p-button
            class="search-button"
            [label]="this.jezik === Language.EN ? 'Search' : 'Prikaži'"
            icon="fa-solid fa-search"
            (onClick)="readFilter()"
          ></p-button>
        </div>
        <div class="md:col-6 lg:col-6 flex justify-content-start">
          <p-button
            class="reset-button"
            [label]="this.jezik === Language.EN ? 'Reset' : 'Počisti'"
            icon="fa-solid fa-xmark"
            (click)="this.clearFilter()"
          ></p-button>
        </div>
      </div>
    </form>
  </div>

  <div class="grid grid-ikone">
    @if (this.gridState.resultSetCount && this.gridState.resultSetCount > 0) {
      <div
        class="md:col-12 lg:col-12 flex align-items-center justify-content-end tabela-icons-row"
        style="position: relative; padding-top: 0; margin-top: -20px"
      >
        <!-- separation line -->
        <div class="icons-separator-line"></div>
        <!-- icons group -->
        <div class="icons-group">
          <a
            tabindex="0"
            class="tabela-ikona"
            (click)="this.expendTable()"
            (keyup.enter)="this.expendTable()"
          >
            @if (!this.tabelaRazsirjena) {
              <i
                class="fa-solid fa-arrows-left-right-to-line"
                [pTooltip]="this.jezik === Language.EN ? 'Show all columns' : 'Prikaži vse stolpce'"
                tooltipPosition="bottom"
              ></i>
            }
            @if (this.tabelaRazsirjena) {
              <i
                class="fa-solid fa-arrows-to-line"
                style="transform: rotate(90deg)"
                [pTooltip]="
                  this.jezik === Language.EN ? 'Hide extra columns' : 'Skrij dodatne stolpce'
                "
                tooltipPosition="bottom"
              ></i>
            }
          </a>
          @if (this.grupeZaprte) {
            <a
              tabindex="0"
              class="tabela-ikona"
              (click)="this.expendGroups()"
              (keyup.enter)="this.expendGroups()"
              [pTooltip]="this.jezik === Language.EN ? 'Expand all' : 'Razpri vse vrstice'"
              tooltipPosition="bottom"
            >
              <i class="fa-solid fa-arrows-from-line"></i>
            </a>
          }
          @if (!this.grupeZaprte) {
            <a
              tabindex="0"
              class="tabela-ikona"
              (click)="this.collapseGroups()"
              (keyup.enter)="this.collapseGroups()"
              [pTooltip]="this.jezik === Language.EN ? 'Collapse all' : 'Skrči vse vrstice'"
              tooltipPosition="bottom"
            >
              <i class="fa-solid fa-arrows-to-line"></i>
            </a>
          }
          <a
            tabindex="0"
            class="tabela-ikona"
            (click)="this.exportToExcel()"
            (keyup.enter)="this.exportToExcel()"
            style="padding-right: 30px"
            [pTooltip]="this.jezik === Language.EN ? 'Export to Excel' : 'Izvozi v Excel'"
            tooltipPosition="bottom"
          >
            <i class="far fa-file-excel"></i>
          </a>
        </div>
      </div>
    }
  </div>

  <ix-flex-grid-report #reportGrid [gridState]="this.gridState"></ix-flex-grid-report>
  @if (this.gridState.resultSetCount && this.gridState.resultSetCount > this.limitVrstic) {
    <lib-flexgrid-paginator
      #paginator
      [flexGrid]="this.gridState.theGrid"
      (pageChanged)="onPageChanged()"
    ></lib-flexgrid-paginator>
  }
</div>
@if (ixNgValidationService.appIxNotificationOpen) {
  <ix-validation-dialog></ix-validation-dialog>
}
